module.exports = require('relevant-shared/misc/sharedConstants');
